<template>
  <div class="home">
    <Navbar />
    <DashBoard TIME="7 NGÀY GẦN NHẤT"/>
    <vue-headful title="REPORT LAST WEEK" />
  </div>
</template>

<script>
// @ is an alias to /src
import DashBoard from "@/components/DashBoard.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "Home",
  components: {
    DashBoard,
    Navbar,
  },
};
</script>
<style>
body {
  background-color: white !important;
}

.footer {
  color: black !important;
}
</style>